import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import LaMaison from './pages/LaMaison';
import Collection from './pages/Collection';
import ProductDetail from './pages/ProductDetail';
import NotreVision from './pages/NotreVision';
import Transparence from './pages/Transparence';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import Login from './pages/Login';

function AppContent() {
  const location = useLocation();
  const isProduct = location.pathname.startsWith('/collection/') && location.pathname !== '/collection';
  const isLogin = location.pathname === '/login';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {!isLogin && <Navbar />}
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/la-maison" element={<LaMaison />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/collection/:id" element={<ProductDetail />} />
          <Route path="/notre-vision" element={<NotreVision />} />
          <Route path="/transparence" element={<Transparence />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<Legal />} />
          <Route path="/politique-confidentialite" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </main>
      {!isProduct && !isLogin && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
